import { jsx, jsxs } from "react/jsx-runtime";
import react from "react";
import CloseCircle from "@crehana/compass.icons.fill/CloseCircle";
import Search from "@crehana/compass.icons.outline/Search";
import { cn } from "../../utils.js";
const SearchInputVariant = /*#__PURE__*/ react.forwardRef(({ className, debounceDelay = 300, value, onChange, onSearch, onClear, ...props }, ref)=>{
    const [searchValue, setSearchValue] = react.useState(value?.toString() ?? '');
    if (void 0 !== value && !onSearch && !onChange) console.warn('Do not use value without onChange or onSearch function. The value will be uncontrolled.');
    const usedValue = void 0 === value || onSearch ? searchValue : value.toString();
    react.useEffect(()=>{
        if (!onSearch) return;
        if (value === searchValue) return;
        const timer = setTimeout(()=>{
            onSearch(searchValue);
        }, debounceDelay);
        return ()=>clearTimeout(timer);
    }, [
        debounceDelay,
        value,
        searchValue
    ]);
    const handleSearchClear = ()=>{
        setSearchValue('');
        onClear?.();
    };
    return /*#__PURE__*/ jsxs("div", {
        className: "tw-relative tw-flex tw-items-center",
        children: [
            /*#__PURE__*/ jsx("input", {
                ref: ref,
                className: cn('tw-pl-4.4 tw-pr-3.2', className),
                onChange: (e)=>{
                    if (onChange) onChange(e);
                    setSearchValue(e.target.value);
                },
                value: usedValue,
                ...props
            }),
            /*#__PURE__*/ jsx(Search, {
                size: 24,
                className: "tw-absolute tw-left-1.2 tw-text-neutral-light-600 dark:tw-text-neutral-dark-500"
            }),
            /*#__PURE__*/ jsx("button", {
                type: "button",
                className: cn('tw-absolute tw-right-1.2 tw-text-neutral-light-600 dark:tw-text-neutral-dark-500 hover:tw-text-primary-light-500 dark:hover:tw-text-primary-dark-400', 0 === usedValue.length && 'tw-hidden'),
                onClick: handleSearchClear,
                children: /*#__PURE__*/ jsx(CloseCircle, {
                    size: 16,
                    className: "tw-text-inherit"
                })
            })
        ]
    });
});
export { SearchInputVariant };
